<template>
  <ul>
    <li v-for="(announcement, index) in visibleAnnouncements" :key="index">
      <Banner
        theme="orange"
        icon="info-icon-alt"
        class="tw-mt-4 tw-mx-4"
        @close="close(announcement)"
      >
        <template v-slot:title>
          <p class="tw-text-xl tw-font-medium">{{ announcement.title }}</p>
        </template>
        <template>
          <!-- eslint-disable vue/no-v-html -->
          <div
            class="announcement-container"
            v-html="announcement.content"
          ></div>
          <!-- eslint-enable -->
        </template>
      </Banner>
    </li>
  </ul>
</template>

<script>
import Banner from '@/components/Banner.vue'
import Profile from '@/api/profile/Profile'

export default {
  name: 'AnnouncementList',
  components: {
    Banner,
  },

  props: {
    announcements: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      visibleAnnouncements: [...this.announcements],
    }
  },

  methods: {
    async close(announcement) {
      try {
        await Profile.hideAnnouncement(announcement)
        this.visibleAnnouncements = this.visibleAnnouncements.filter(
          a => a.id !== announcement.id
        )
      } catch (error) {
        this.error('Failed to close announcement.')
      }
    },
  },
}
</script>
